// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/proforme-acconto/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","numero":"string","origine":"string","stato":"string","imponibile":"string","iva":"string","totale":"string","clienteRagioneSociale":"string|null","dataEmissione":"string","dataPagamento":"string|null","dataAnnullamento":"string|null","motivoAnnullamento":"string|null","societaId":"number","commessa":{"id":"number","numero":"string"},"ordine":{"id":"number","numero":"string"}|null,"acquirente":{"id":"number","nome":"string","cognome":"string"}|null,"movimenti":[{"id":"number","importo":"string","dataIncasso":"string","canale":"string","note":"string|null","registratoAt":"string","contabile":{"id":"number","nome":"string","nomeFile":"string"}|null,"fattura":{"id":"number","numero":"string|null","statoFattura":"string"}|null}],"logs":[{"id":"number","utenteName":"string","azione":"string","dettaglio":"string|null","createdAt":"string"}],"totaleIncassato":"number","residuo":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/fatture/da-acconto',
    requestBody: '{"proformaAccontoId":"number"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/proforme-acconto/:id/incassi',
    requestBody: '{"importo":"number","dataIncasso":"string","note":"string?","scelta":"string","contabile":"File"}',
    response: '{"success":true,"data":{"movimentoId":"number","fatturaId":"number","fatturaStato":"string","statoProforma":"string","totaleIncassato":"number","residuo":"number","rettificaOrdine":"object|null"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/proforme-acconto/:id/annulla',
    requestBody: '{"motivoAnnullamento":"string"}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
